<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="chapter-one">
<h1>Chapter One</h1>
<p>St John’s Church was built in the 1300s. The stones had worn with age of time and the Cornish coastal air. The tombs and graves were cracked and worn holding stories of their own.</p>
<p>Old yew trees are spread across and around the church holding stories of yesteryear and of ancient worship of druids. Some even say witchcraft and devil worship were used on the grounds and surrounding areas.</p>
<p>Winding narrow roads are well-kept and signs posted all the way to St John’s surrounded by overhung trees and bushes that hide the road from any building.</p>
<p>Tonight was a particularly chilly evening and the moon was full in the night sky.</p>
<p>The stars where twinkling against that black canvas and the moon looked larger than normal and so clear you could almost see the craters, well so it seemed.</p>
<p>The church stood bold and silent silhouetted against the light of the moon, the graveyard was well kept apart from a few headstones that were overgrown and had been neglected over the years of time.</p>
<p>There are three new graves almost next to each other and are clearly visible in the light of the moon. You could just about see the colour of the dirt.</p>
<p>Beneath the dirt lies another story.</p>
<p>Six feet down lays a coffin. Beneath that coffin lid lays the body of a young girl. Skin as pale as ivory and body as cold as ice dressed in a shroud as pale as her skin.</p>
<p>Suddenly her eyes open. She gasps revealing sharp canine fangs.</p>
<p>The wreath on her grave shrivels up and dies in seconds.</p>
<p style="text-align: center; padding-top:25px; padding-bottom:20px;">***</p>
<p>“You can put that light out now, it’s time to go to sleep.”</p>
<p>Lewis shuts the book with a thud.</p>
<p>“Oh Mum it was just getting good.”</p>
<p>“Lights out, please.”</p>
<p>Tanya is a good mum, she lets Lewis get away with almost everything, his father however having that Latin temperament was just a little stricter. Lewis always knew how far to go.</p>
<p>“You heard your mum.”</p>
<p>“Yes, Dad.”</p>
<p>Lewis puts the book on the floor by the bed and turns out his light.</p>
<p>Carlos is staring out of the French windows of their modest cottage.</p>
<p>“What are you looking at darling?”</p>
<p>“The moon, it’s really low tonight.”</p>
<p>Tanya joins Carlos and wraps her arms around him looking out at the moon.</p>
<p>“Yes it’s really low and so big tonight.”</p>
<p>They both stand mesmerised almost hypnotised for just a few moments.</p>
<p>“OK, hot chocolate or Horlicks, what will it be tonight?”</p>
<p>Tanya kisses Carlos on the cheek.</p>
<p>“Oh, I’m in a chocolate mood, dark and hot please.”</p>
<p>Carlos laughs then kisses Tanya’s nose.</p>
<p>“Just like your man then.”</p>
<p>Tanya giggles then sits down on the sofa and grabs a magazine lying on the coffee table.</p>
<p>Flicking through the pages of the TV guide Tanya calls out.</p>
<p>“Do you fancy watching a film?”</p>
<p>Carlos mumbles, “I don’t mind.”</p>
<p>“What are you eating?”</p>
<p>“A biscuit.”</p>
<p>Tanya smiles to herself.</p>
<p>Carlos enters carrying a tray with two mugs and a plate of biscuits.</p>
<p>Carlos has a whole biscuit sticking out of his mouth.</p>
<p>“Oh, you are so romantic.”</p>
<p>Carlos sits down next to Tanya on the sofa.</p>
<p>Tanya takes a biscuit and kisses Carlos then pops the biscuit in Carlos’s mouth.</p>
<p>Mumbling and juggling the biscuit in his mouth Carlos replies.</p>
<p>“Yep, you know it babe.”</p>
<p>Tanya slaps the TV guide.</p>
<p>“Right, what are we going to watch, there is, let me see, Titanic again.”</p>
<p>Carlos interrupts. “Oh no that’s too long.”</p>
<p>Tanya continues looking.</p>
<p>“OK, here we go, what about a good old-fashioned Hammer horror?”</p>
<p>Raising her eyebrows, “The Devil Rides Out?”</p>
<p>Carlos nods sipping his chocolate.</p>
<p>“Is that with Peter Cushing?”</p>
<p>Tanya puts the magazine back on the coffee table.</p>
<p>“No, it’s with Christopher Lee.”</p>
<p>Carlos’s eyes light up like a child with a new toy.</p>
<p>“Oh I like Christopher Lee; he was a great, yeah let’s put that one on. Anyway, we know the ending in the Titanic— everyone dies.”</p>
<p>Tanya laughs.</p>
<p>Carlos laughs too.</p>
<p>“What are you laughing at?”</p>
<p>Tanya kisses Carlos.</p>
<p>“I think you will find they all die in this one too at the end.”</p>
<p>“Damn Tanya, now you’ve gone and spoiled it.”</p>
<p>Carlos laughs and switches on the TV with the remote control.</p>
<p>They lounge back on the sofa together and the opening credits are already rolling.</p>
<p>Carlos looks at Tanya.</p>
<p>“This is going to be good.”</p>
<p>Tanya looks surprised.</p>
<p>“You haven’t seen this before?”</p>
<p>“Sure I have, that’s how I know, oh by the way, they do not all die in the end!”</p>
<p style="text-align: center; padding-top:25px; padding-bottom:20px;">***</p>
<p>The clock on the tower of St John’s Church was shining bright showing the time. Larry checks his wristwatch against the church clock – 11:45 pm.</p>
<p>“Well I knew it was late but, oh well.”</p>
<p>Larry stops and swings his shovel over his shoulder as he bends down and picks up an old copy of The Cornish Times.</p>
<p>“The rubbish that blows in here, sweet wrappers, newspapers, I don’t know.”</p>
<p>Larry has been the ground man and caretaker of St John’s for twenty two years and has got to know the locals in the village very well.</p>
<p>Larry being quite a character but not really the sharpest knife in the draw at times, is a loveable chap, or so they say. Although only in his early fifties, he still could be mistaken for late forties with a good clean up. He is six feet tall and slim with greying hair in need of a wash, dirty nails and a moustache that needs a trim.</p>
<p>“Time to put this lot in the van and head on home.”</p>
<p>Often Larry would chat away to himself while he’s working or sing a little song.</p>
<p>He always has a smile and a tale to tell wherever he goes and with whomever he meets.</p>
<p>In the churchyard, the wind continues to howl through the trees. Larry looks up to the trees.</p>
<p>“Yes, I know you’re waking up, blowing old leaves all over my freshly cleaned up graves. Oh well, that’ll give me something to do when morning breaks.”</p>
<p>Larry swings the shovel back around and sticks it into the fresh soil of the grave, then puts the old newspaper in the black bag on the floor.</p>
<p>Picking up the bag, Larry shivers.</p>
<p>Larry shakes his head he chuckles to himself.</p>
<p>“Sleep tight.”</p>
<p>He throws the bin into his wheelbarrow and walks off down the path towards the gated entrance of the churchyard.</p>
<p>The paths were clean and well kept, the grass was in perfect condition.</p>
<p>The railings around the graveyard were in need of a lick of paint and the gate needs oiling but that was on his list of things to do.</p>
<p>The wind howled and blew across the graveyard as Larry reached his van.</p>
<p>A flower blew in the wind onto the grave and stopped when it hit Larry’s shovel.</p>
<p>The dirt on the grave moves and shudders, the flower begins to decompose and die.</p>
<p>Just along the path outside the church is a large industrial bin where Larry throws his rubbish. He heads back to the van and as he opens the doors, they creak.</p>
<p>“What is it with doors?”</p>
<p>Larry puts the barrow in the back of the van along with endless tools and ropes and reels of wire and sacks scattered in no particular order all over the place. The light in the back flickers on and off.</p>
<p>Larry shakes his head.</p>
<p>“That’s another couple of jobs to do. Oil the gates and these doors and fix the light. Never ending this job is. Work, work, work and more bloody work, oh well, that’s life I suppose.”</p>
<p>The soil continued to shudder and fresh soil rolled to the sides. The shovel fell to the side of the grave, and then everything stopped, just silence.</p>
<p>Then bang. The soil flew into the air and the lid from the coffin followed like an explosion.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch005.vue?36037efa